export default __webpack_public_path__ + "static/media/logo-union-europea.30ffa093.png";